import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'ts-badge',
  templateUrl: './base-badge.component.html',
  imports: []
})
export class BaseBadgeComponent {
  @Input() variant: string = 'info';
  @Input() mode: 'default' | 'outline' | 'themed' = 'default';
  @Input() text: string;
  @Input() class: string = '';

  @HostBinding('class') get classes(): string {
    let badge_class: string = '';
    switch (this.mode) {
      case 'outline': {
        badge_class = `badge-outline-${this.variant}`;
        break;
      }
      case 'themed': {
        badge_class = `themed-badge-${this.variant}`;
        break;
      }
      default: {
        badge_class = `badge-${this.variant}`;
        break;
      }
    }

    return `${this.class ? `${this.class} ` : ''}${badge_class}`;
  }
}
